{
	"pick": "Timer to follow",
	"optionSimulated": "{{bench}} (simulated)",
	"simulated": "Simulated",
	"updated": "Updated {{time}}",
	"noRace": "This timer has no race yet.",
	"readError": "No answer from the timer relay. Retrying.",
	"dismiss": "Dismiss",
	"warnings_one": "{{count}} timer warning",
	"warnings_other": "{{count}} timer warnings",
	"raceOn": "On {{race}}",
	"dropped": "Not applied: the meet already has a later timer message.",
	"nothingNew": "Applied. Nothing new to write.",
	"applied_one": "Applied: {{count}} row written.",
	"applied_other": "Applied: {{count}} rows written.",
	"error": {
		"notFound": "This timer has no race to apply.",
		"changed": "The device has sent a newer reading since you looked. Check it, then apply again."
	},
	"relay": {
		"open": "Read the timer from this computer",
		"title": "This computer",
		"hint": "Chrome or Edge on the venue network. Sends the timer's reading to the server; applying stays your click.",
		"address": "Timer address",
		"benchId": "Send as",
		"start": "Start",
		"stop": "Stop",
		"invalidAddress": "Enter the timer's address, e.g. {{example}}.",
		"invalidBenchId": "Use letters, digits, - and _ (up to 40).",
		"connecting": "Connecting to the timer…",
		"relaying": "Relaying as {{bench}}, last sent {{time}}",
		"paused": "Paused while this tab is hidden.",
		"timerDown": "The timer is not answering.",
		"timerHint": "Use Chrome or Edge, allow \"devices on your local network\", and be on the venue network.",
		"refused": "The server refused the timer's reading ({{code}}). Waiting for new timer data.",
		"apiDown": "Cannot reach the server. Retrying.",
		"simulated": "This timer is a simulator, not live hardware."
	},
	"actionError": {
		"stale": "Someone else changed this first. It has been reloaded; enter your change again.",
		"official": "The meet is official. To make changes, change the Meet status (you will be asked to confirm).",
		"locked": "The medal desk has locked this event.",
		"lineup_strangers": "Someone in this line-up is not on the team roster.",
		"validation": "Some values were not accepted.",
		"family_changed": "This meet's result type changed. Reload the meet.",
		"offline": "No answer from the server. Your change is kept here; try again.",
		"forbidden": "Your role cannot make this change.",
		"not_found": "This was not found. It may have been removed.",
		"auth": "Your session ended. Sign in again, then save.",
		"unknown": "The change was not saved. Try again."
	},
	"stale": {
		"silent": "No new reading since {{time}}, but the timer's clock was still running. Check that this computer or the bridge is still reading the timer.",
		"old_one": "This reading is from {{time}}, {{count}} minute ago. It may be another race.",
		"old_other": "This reading is from {{time}}, {{count}} minutes ago. It may be another race.",
		"confirmTitle": "Apply an old reading?",
		"confirm": "Apply anyway"
	},
	"console": {
		"stale": {
			"old_one": "This card is from {{time}}, {{count}} minute ago. It may be another competition.",
			"old_other": "This card is from {{time}}, {{count}} minutes ago. It may be another competition."
		},
		"pick": "Field console to follow",
		"noRace": "This field console has no competition yet.",
		"readError": "No answer from the field console relay. Retrying.",
		"warnings_one": "{{count}} field console warning",
		"warnings_other": "{{count}} field console warnings",
		"relay": {
			"open": "Read the field console from this computer",
			"hint": "Chrome or Edge on the venue network. Sends the field console's card to the server.",
			"address": "Console address",
			"invalidAddress": "Enter the field console's address, e.g. {{example}}.",
			"connecting": "Connecting to the field console…",
			"timerDown": "The field console is not answering.",
			"refused": "The server refused the field console's card ({{code}}). Waiting for new data.",
			"simulated": "This field console is a simulator, not live hardware."
		}
	},
	"auto": {
		"label": "Auto-apply",
		"hint": "On this computer: each new attempt from the field console is saved into the grid by itself. Results you typed are never replaced.",
		"on": "Auto-apply is on: each attempt is saved as the field console sends it.",
		"waiting": "Auto-apply is waiting: save or discard your edits in the grid first."
	},
	"applyNow": "Apply now",
	"early": {
		"confirmTitle": "Apply before the race is finished?",
		"confirm": "Apply now"
	}
}
